// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VbFiO99UwGMWaGDXHTha {
  display: flex;
}
@media only screen and (max-width: 1023px) {
  .VbFiO99UwGMWaGDXHTha {
    display: block;
  }
}

.eIWNRFniUfA_UAdsgd9t:first-child {
  flex: 0 0 100%;
  width: 100%;
  padding-right: 8px;
}
@media only screen and (max-width: 1259px) {
  .eIWNRFniUfA_UAdsgd9t:first-child {
    flex: 0 0 100%;
    width: 100%;
  }
}
@media only screen and (max-width: 1023px) {
  .eIWNRFniUfA_UAdsgd9t:first-child {
    width: 100%;
    padding: 0;
  }
}

.SIAcQXGN_gk1X3dzJpE0:not(:last-child) {
  margin-bottom: 8px;
}

@media only screen and (max-width: 767px) {
  .MfF2dPj99sTlbPOOWBpn {
    display: block;
  }
}

.fHUhIn29IX5aFNMxZnsg {
  margin-right: auto;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  color: #6F767E;
}
@media only screen and (max-width: 767px) {
  .fHUhIn29IX5aFNMxZnsg {
    margin: 0 0 24px;
  }
}
.fHUhIn29IX5aFNMxZnsg svg {
  margin-right: 12px;
  fill: #6F767E;
}
.fHUhIn29IX5aFNMxZnsg span {
  color: #1A1D1F;
}
.dark-mode .fHUhIn29IX5aFNMxZnsg span {
  color: #FCFCFC;
}

.yCARfVyM3I1Q3zhCWl8E {
  display: flex;
  align-items: center;
}

.WYZ30SAGg_g9NhtkbxvV {
  margin-right: 8px;
}
@media only screen and (max-width: 767px) {
  .WYZ30SAGg_g9NhtkbxvV {
    flex-grow: 1;
  }
}

.sKcNKyrzgPHhmZsGHg7t {
  width: 48px;
  height: 48px;
  border: 2px solid #EFEFEF;
  border-radius: 12px;
  transition: all 0.2s;
}
.sKcNKyrzgPHhmZsGHg7t svg {
  transform: rotate(90deg);
  fill: #6F767E;
}
.sKcNKyrzgPHhmZsGHg7t:hover {
  background: #EFEFEF;
}
.sKcNKyrzgPHhmZsGHg7t:hover svg {
  fill: #1A1D1F;
}
.dark-mode .sKcNKyrzgPHhmZsGHg7t {
  border-color: #272B30;
  background: transparent;
}

.CWbYFN1CADaGkiUQTDBK:first-child {
  display: none;
}
@media only screen and (max-width: 1023px) {
  .CWbYFN1CADaGkiUQTDBK:first-child {
    display: flex;
  }
}

.LghgSzOlhbJnD4DXz1hx {
  right: 0;
}
.LghgSzOlhbJnD4DXz1hx:before {
  right: 14px;
}`, "",{"version":3,"sources":["webpack://./src/pages/banner-editor/page-editor.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;AADJ;ACWI;EDXJ;IAGQ,cAAA;EACN;AACF;;AACI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AAER;ACHI;EDFA;IAKQ,cAAA;IACA,WAAA;EAIV;AACF;ACNI;EDLA;IAQQ,WAAA;IACA,UAAA;EAOV;AACF;;AANI;EACI,kBAAA;AASR;;ACbI;EDQJ;IAEQ,cAAA;EAQN;AACF;;AAPA;EACI,kBAAA;ECiFA,eAAA;EACA,gBAAA;EACA,yBAAA;EDjFA,cCaC;ADDL;AC3BI;EDYJ;IAKQ,gBAAA;EAcN;AACF;AAdI;EACI,kBAAA;EACA,aCQH;ADQL;AAfI;EACI,cCSH;ADQL;ACqIa;EDpJD,cCCP;ADiBL;;AAhBA;EACI,aAAA;EACA,mBAAA;AAmBJ;;AAjBA;EACI,iBAAA;AAoBJ;ACnDI;ED8BJ;IAGQ,YAAA;EAsBN;AACF;;AArBA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AAwBJ;AAvBI;EACI,wBAAA;EACA,aCfH;ADwCL;AAxBI;EACI,mBClBH;AD4CL;AAzBQ;EACI,aChBP;AD2CL;ACkGa;ED3HL,qBCnBH;EDoBG,uBAAA;AA4BR;;AAzBI;EACI,aAAA;AA4BR;ACrFI;EDwDA;IAGQ,aAAA;EA8BV;AACF;;AA7BA;EACI,QAAA;AAgCJ;AA/BI;EACI,WAAA;AAiCR","sourcesContent":["@import ../../styles/helpers\n\n.row\n    display: flex\n    +t\n        display: block\n\n.col\n    &:first-child\n        flex: 0 0 calc(100% )\n        width: calc(100% )\n        padding-right: 8px\n        +d\n            flex: 0 0 calc(100%)\n            width: calc(100% )\n        +t\n            width: 100%\n            padding: 0\n.card\n    &:not(:last-child)\n        margin-bottom: 8px\n\n\n\n.panel\n    +m\n        display: block\n\n.info\n    margin-right: auto\n    +caption1\n    color: $n4\n    +m\n        margin: 0 0 24px\n    svg\n        margin-right: 12px\n        fill: $n4\n    span\n        color: $n7\n        +dark\n            color: $n1\n\n.btns\n    display: flex\n    align-items: center\n\n.button\n    margin-right: 8px\n    +m\n        flex-grow: 1\n\n.actionsHead\n    width: 48px\n    height: 48px\n    border: 2px solid $n3\n    border-radius: 12px\n    transition: all .2s\n    svg\n        transform: rotate(90deg)\n        fill: $n4\n    &:hover\n        background: $n3\n        svg\n            fill: $n7\n    +dark\n        border-color: $n6\n        background: transparent\n\n.actionsOption\n    &:first-child\n        display: none\n        +t\n            display: flex\n\n.actionsBody\n    right: 0\n    &:before\n        right: 14px\n","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `VbFiO99UwGMWaGDXHTha`,
	"col": `eIWNRFniUfA_UAdsgd9t`,
	"card": `SIAcQXGN_gk1X3dzJpE0`,
	"panel": `MfF2dPj99sTlbPOOWBpn`,
	"info": `fHUhIn29IX5aFNMxZnsg`,
	"btns": `yCARfVyM3I1Q3zhCWl8E`,
	"button": `WYZ30SAGg_g9NhtkbxvV`,
	"actionsHead": `sKcNKyrzgPHhmZsGHg7t`,
	"actionsOption": `CWbYFN1CADaGkiUQTDBK`,
	"actionsBody": `LghgSzOlhbJnD4DXz1hx`
};
export default ___CSS_LOADER_EXPORT___;
